/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentEditorAddressViewModel } from "../types/IndividualPaymentEditorAddressViewModel.ts";

export const individualPaymentEditorAddressViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  street: z.string().nullish(),
  placeNumber: z.string().nullish(),
  neighborhood: z.string().nullish(),
  zipCode: z.string().nullish(),
  postCode: z.string().nullish(),
  countryId: z.optional(z.number().int()),
  stateId: z.number().int().nullish(),
  cityId: z.number().int().nullish(),
  stateName: z.string().nullish(),
  cityName: z.string().nullish(),
  observations: z.string().nullish(),
}) as unknown as ToZod<IndividualPaymentEditorAddressViewModel>;
